/* eslint-disable */
// ####################################+################################################
// ################# THIS IS GENERATED FILE DO NOT TOUCH!!!!!!!!!!!!####################
// ####################################-################################################
import type * as Types from '../packlets/generated'

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type DiscordInterestBaseFragmentFragment = {
  __typename?: 'DiscordInterest'
  type: Types.DiscordInterestType
  name: string
  description?: string | null | undefined
}

export type GetDiscordInterestsQueryVariables = Types.Exact<{
  input: Types.GetDiscordInterestsOptionsInput
}>

export type GetDiscordInterestsQuery = {
  __typename?: 'Query'
  getDiscordInterests: {
    __typename?: 'GetDiscordInterestsResponse'
    interests: Array<{
      __typename?: 'DiscordInterest'
      type: Types.DiscordInterestType
      name: string
      description?: string | null | undefined
    }>
  }
}

export const DiscordInterestBaseFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DiscordInterestBaseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DiscordInterest' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscordInterestBaseFragmentFragment, unknown>
export const GetDiscordInterestsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDiscordInterests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetDiscordInterestsOptionsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDiscordInterests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interests' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DiscordInterestBaseFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...DiscordInterestBaseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetDiscordInterestsQuery,
  GetDiscordInterestsQueryVariables
>
